/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';

import { Stores, useStores } from '@src/store';

// 保留store里类型是函数属性声明（action），其余类型都过滤掉
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
type ActionsType<T> = { [K in keyof T as T[K] extends Function ? K : never]: T[K] }

/**
 * 使用mobx的action，改变store状态。避免在react组件里直接引用mobx store
 * @returns actions
 */
function useMobxActions() {
  const stores = useStores();
  return useMemo(() => {
    const actions = {} as {
      [K in keyof Stores]: ActionsType<Stores[K]>
    };

    for (const key in stores) {
      const storeName = key as keyof Stores;
      actions[key as keyof Stores] = new Proxy({}, {
        get(_, actionName) {
          const store = stores[storeName] as any;
          return (...args: any[]) => {
            if (!store[actionName] || typeof store[actionName] !== 'function') {
              throw new Error(`Action ${String(actionName)} is not exit, or not a function`);
            }
            return store[actionName](...args);
          };
        },
      }) as any;
    }

    return actions;
  }, [stores]);

}

export default useMobxActions;